const g = globalThis as typeof globalThis & {
  pushNotification?: (type: string, message: string) => void;
};

export function notify(type: string, message: string): void {
  g.pushNotification?.(type, message);
}
